import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../../cmsHooks/useIndexPageData'

import { SectionHeader } from '../../../ui'

const Link = styled.a``
const Logo = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const ClientList = styled.ul``
const Client = styled.li``

const Clients = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <SectionHeader>
      <CMS.Text name="Clients headline" data={data} />
    </SectionHeader>
  )
}

export default Clients
